<template>
  <button
    class="pill"
    :class="active && 'pill--active'"
    type="button"
    :aria-pressed="active"
    @click="$emit('click', $event)"
    @keyup.enter="$emit('click', $event)"
  >
    <IconCheck v-if="active" aria-hidden="true" />
    <span>{{ label }}</span>
  </button>
</template>

<script>
import IconCheck from '@/components/icons/IconCheck.vue'

export default {
  components: { IconCheck },
  props: {
    label: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
}
</script>

<style lang="scss">
.pill {
  @include small-text;
  background-color: $color-grey-light;
  border-radius: 16px;
  cursor: pointer;
  font-weight: $font-weight-medium;
  padding: 4px 20px;
  border: none;

  &:focus-visible {
    outline: 2px solid $color-info-primary;
    outline-offset: 2px;
  }

  &:hover {
    background-color: $color-grey-dark;
  }

  &--active {
    @include flex-center-align;
    background-color: $color-yellow-primary;
    gap: 4px;
    padding: 4px 8px;

    &:hover {
      background-color: $color-yellow-dark;
    }
  }
}
</style>
